// extracted by mini-css-extract-plugin
export default {"section":"SinglePage_section__h0Zxj","title":"SinglePage_title__41gfV","item":"SinglePage_item__5G1Bt","label":"SinglePage_label__Y8LuX","value":"SinglePage_value__e-Xaj"};